<h1>Problem Listing</h1>

<app-mat-autocomplete placeholder="Search Problems" [alwaysShowAddCard]="true" [searchObservable]="searchProblems$" (addNewItem)='onAddNewItem()' [addItemCardText]="'Add new problem item.'"
[displayResultsCardTemplate]='displayResultsCardTemplate'  *appPermissionRequired="'Clinical.ProblemListing.Write'"></app-mat-autocomplete>
<ng-template #displayResultsCardTemplate let-result="result" let-queryText="queryText">
  <div class="d-flex flex-row justify-content-between align-items-center">
    <span [innerHtml]="result.problem | textHighlight: queryText"></span>
    <button mat-icon-button (click)="onItemSelected(result)"><mat-icon>add</mat-icon></button>
  </div>
  <mat-form-field color="primary" appearance="fill" class="compact w-100" subscriptSizing="dynamic">
    <mat-label>Comments/Notes</mat-label>
    <input matInput type="text" [(ngModel)]="result.comment"/>
  </mat-form-field>
</ng-template>

@if (loading) {
  <app-loading-spinner></app-loading-spinner>
}

<div class="mat-card-list" *appPermissionRequired="'Clinical.ProblemListing.Read';">
  @for (item of problems; track item.id) {
    <mat-card class="compact">
      <app-problem-item [item]="item" [usePrimaryText]="settings.themeWidgetText" class="w-100"></app-problem-item>
    </mat-card>
  }

  @if (!hasProblems) {
    <mat-card>
      <mat-card-content>
        <span>No problems have been added to this patient.</span>
      </mat-card-content>
    </mat-card>
  }

</div>
